import { DeviceType } from "@altertec_gparn/lib";

type RequestMethodType = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

type RequestType = "json" | "text" | "form-data";

type RequestHeadersType = { [key: string]: string };

type HttpRequestConstructor<BodyType> = {
  url: string;
  method?: RequestMethodType;
  type?: RequestType;
  auth?: boolean;
  headers?: RequestHeadersType;
  body?: BodyType;
  query?: string;
  device?: DeviceType;
  location?: string;
};

export class HttpRequest<BodyType> {
  url: string;
  method: RequestMethodType;
  type: RequestType;
  auth: boolean;
  headers: RequestHeadersType;
  body: BodyType;
  query: string;
  device?: DeviceType;
  location?: string;

  static create<BodyType>(config: HttpRequestConstructor<BodyType>): HttpRequest<BodyType> {
    const httpRequest = new HttpRequest<BodyType>();
    httpRequest.url = config.url;
    httpRequest.method = config.method || "GET";
    httpRequest.type = config.type || "json";
    httpRequest.auth = config.auth || false;
    httpRequest.headers = config.headers || {};
    httpRequest.body = config.body || null;
    httpRequest.query = config.query || "";
    httpRequest.device = config.device || HttpRequest.detectDevice();
    httpRequest.location = config.location;

    if (httpRequest.device) {
      httpRequest.headers["x-device-type"] = httpRequest.device;
    }
    if (httpRequest.location) {
      httpRequest.headers["x-location"] = httpRequest.location;
    }
    return httpRequest;
  }

  private static detectDevice(): DeviceType {
    if (typeof navigator === "undefined") return DeviceType.COMPUTER;

    const userAgent = navigator.userAgent.toLowerCase();
    if (
      userAgent.includes("mobile") ||
      userAgent.includes("android") ||
      userAgent.includes("iphone") ||
      userAgent.includes("ipad")
    ) {
      return DeviceType.MOBILE;
    }
    return DeviceType.COMPUTER;
  }
}
